var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendar2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendario",
    width: 17.14,
    height: 17.14,
    viewBox: "0 0 17.14 17.14",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M15.176,58.379H1.964A1.966,1.966,0,0,1,0,56.415V44.632a1.965,1.965,0,0,1,1.964-1.964H15.176a1.965,1.965,0,0,1,1.964,1.964V56.415A1.966,1.966,0,0,1,15.176,58.379ZM1.964,43.739a.894.894,0,0,0-.893.893V56.415a.894.894,0,0,0,.893.893H15.176a.894.894,0,0,0,.893-.893V44.632a.894.894,0,0,0-.893-.893Zm0,0",
    transform: "translate(0 -41.24)",
    fill: "#016ece"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M16.6,171.739H.536a.536.536,0,1,1,0-1.071H16.6a.536.536,0,1,1,0,1.071Zm0,0",
    transform: "translate(0 -164.955)",
    fill: "#016ece"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M107.2,4.285a.536.536,0,0,1-.536-.536V.536a.536.536,0,1,1,1.071,0V3.749A.536.536,0,0,1,107.2,4.285Zm0,0",
    transform: "translate(-103.097)",
    fill: "#016ece"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M373.868,4.285a.536.536,0,0,1-.536-.536V.536a.536.536,0,1,1,1.071,0V3.749A.536.536,0,0,1,373.868,4.285Zm0,0",
    transform: "translate(-360.834)",
    fill: "#016ece"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-2.d6a180ca.svg";
export { ForwardRef as ReactComponent };